import { useEffect, useRef } from "react";
import { paintCelestialMap } from "../lib/celestialMap";

export const CelestialMap = ({ record, height = 340 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && record) paintCelestialMap(ref.current, record, height);
  }, [record, height]);

  return (
    <div className="rounded-sm overflow-hidden border border-amber-500/25" data-testid="celestial-map">
      <canvas ref={ref} style={{ width: "100%", height, display: "block" }} />
    </div>
  );
};
